export default __webpack_public_path__ + "static/media/navbarButtons.b4d268f8.PNG";